// This is being used for the comments modal in the salary calculations page
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "content"]

  open(event) {
    event.preventDefault();
    const el = event.currentTarget;
    
    // Show modal overlay
    if (this.hasModalTarget) this.modalTarget.classList.remove("hidden");
    
    // Get comment ID from data attribute
    const commentId = el.dataset.commentsModalCommentId;
    
    // Build URL to load comment with replies
    const url = `/comments/${commentId}/modal`;
    
    // Fetch and load content
    fetch(url)
      .then(response => response.text())
      .then(html => {
        if (this.hasContentTarget) {
          this.contentTarget.innerHTML = html;
        }
      })
      .catch(error => {
        console.error("Error loading comment:", error);
        if (this.hasContentTarget) {
          this.contentTarget.innerHTML = "<p class='text-red-600'>Error loading comment</p>";
        }
      });
  }

  close(event) {
    if (event) event.preventDefault();
    if (this.hasModalTarget) this.modalTarget.classList.add("hidden");
    // Clear content
    if (this.hasContentTarget) {
      this.contentTarget.innerHTML = "";
    }
  }
}

